module.exports = __webpack_public_path__ + "img/ic_logo_bwin.155150e3.svg";